
import React from 'react';

interface ForgotPasswordHeaderProps {
  emailSent: boolean;
}

export const ForgotPasswordHeader: React.FC<ForgotPasswordHeaderProps> = ({ emailSent }) => {
  return (
    <div className="text-center">
      <h1 className="text-3xl font-bold">Reset Password</h1>
      <p className="mt-2 text-muted-foreground">
        {emailSent 
          ? "Check your email for the reset link" 
          : "We'll send you a link to reset your password"}
      </p>
    </div>
  );
};
